import { SegmentedControl, Center } from "@mantine/core";
import { IconLayoutGrid, IconLayoutList } from "@tabler/icons-react";

export type ViewMode = "grid" | "list";

interface Props {
  value: ViewMode;
  onChange: (mode: ViewMode) => void;
}

export function ViewModeToggle({ value, onChange }: Props) {
  return (
    <SegmentedControl
      value={value}
      onChange={(v) => onChange(v as ViewMode)}
      data={[
        {
          value: "grid",
          label: (
            <Center>
              <IconLayoutGrid size={16} />
            </Center>
          ),
        },
        {
          value: "list",
          label: (
            <Center>
              <IconLayoutList size={16} />
            </Center>
          ),
        },
      ]}
    />
  );
}

export default ViewModeToggle;
